(function () {

  var WORD_MAP = {
    'Balance':'/collections/balance','Synergy':'/collections/synergy','Strength':'/collections/strength',
    'Grateful':'/collections/grateful','Harmonious':'/collections/harmonious','Gratitude':'/collections/gratitude',
    'Faith':'/collections/faith','Abundance':'/collections/abundance','Truthful':'/collections/truthful',
    'Glorious':'/collections/glorious','Real':'/collections/real','Lucky':'/collections/lucky-1',
    'Curiosity':'/collections/curiosity','Love':'/collections/love',
    'Respect':'/collections/respect','Oneness':'/collections/oneness','Jazzy':'/collections/jazzy-1',
    'Fearless':'/collections/fearless','Adventurous':'/collections/adventurous','Transcendence':'/collections/transcendence',
    'Vibrant':'/collections/vibrant','Serenity':'/collections/serenity-1','Energy':'/collections/energy',
    'Resilience':'/collections/resilience','Hopeful':'/collections/hopeful','Freedom':'/collections/freedom-1',
    'Patience':'/collections/patience','Fortitude':'/collections/fortitude','Empowering':'/collections/empowering',
    'Joy':'/collections/joy','Alive':'/collections/alive-1','Sharing':'/collections/sharing-1',
    'Calm':'/collections/calm','Compassion':'/collections/compassion'
  };

  var WOI_TYPES = ['Beanie','Framed print','Hoodie','Long sleeve','Phone Case','Sweatshirt','T-shirt','Tote Bag'];

  function getSavedWords() {
    try { return JSON.parse(localStorage.getItem('int_quiz_words') || '[]'); } catch(e) { return []; }
  }

  function renderPills(container, words) {
    if (!container) return;
    container.innerHTML = '';
    if (!words || !words.length) return;

    // Column layout, the one Word pill centred
    container.style.flexDirection = 'column';
    container.style.alignItems = 'center';
    container.style.justifyContent = 'center';
    container.style.gap = '10px';
    container.style.flexWrap = '';

    /* ⚑ 2026-09-02, Nils: "replace the mint fill button/pill with carbon fill
       and linen text. The other two linen fill and carbon text and border."
       Edited HERE, in the cssText, and not in a stylesheet — these pills are
       built in JS with inline styles, and an inline style beats any rule that
       is not !important. Changing it here keeps one source of truth. */
    /* ⚑ 2026-09-05, Nils: "the word buttons in the bundle box should link to
       those word collections."

       WORD_MAP at the top of this script is the only source of these URLs and
       it is NOT guessable: Lucky is /collections/lucky-1, Serenity is
       /collections/serenity-1, Freedom is /collections/freedom-1. So a word
       with no entry is rendered as plain text, exactly as before, rather than
       as a link to a slug that would 404. `Presence` is in the quiz's scrape
       list but not in WORD_MAP, which is the case this guards. */
    function wordEl(word) {
      /* 2026-10-06: locale aware. Shopify.routes.root is "/" or "/da/", the map holds "/collections/x". */
      var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
      var href = WORD_MAP[word] ? root + WORD_MAP[word] : '';
      var el = document.createElement(href ? 'a' : 'span');
      el.textContent = word;
      if (href) {
        el.setAttribute('href', href);
        el.setAttribute('aria-label', word + ' collection');
      }
      return el;
    }

    /* ⚑ 2026-09-02, Nils: "replace the mint fill button/pill with carbon fill
       and linen text. The other two linen fill and carbon text and border."
       Edited HERE, in the cssText, and not in a stylesheet — these pills are
       built in JS with inline styles, and an inline style beats any rule that
       is not !important. Changing it here keeps one source of truth.

       ⚑ cursor AND text-decoration ARE PART OF THAT. Now that these are
       anchors the browser would underline them and colour them as links, so
       both are set explicitly alongside the fill. */
    // MAJOR — first word, dominant visual (carbon fill, linen text, weight 300)
    /* ⚑ 2026-09-05, Nils: "The big word button (Love) should be linne fill."
       It was carbon fill with linen text since 2026-09-02. Now it matches the
       two supporting pills in colour and carries a carbon border like them, so
       what separates it is size and weight of type, not a second colourway:
       26px of padding against 12, 15px type against 10. */
    /* 2026-10-30, Nils: "Make the Word from the quiz appear as the font file in carbon. No border around."
       The Word is drawn with its own lettering, the theme asset woi-mask-<word>.webp (the same file the Iris
       box uses), as a carbon mask: no border, no fill, sized from the file's own proportions. A Word without
       a file stays as carbon type, also without a border. The link to the Word collection stays. */
    var major = wordEl(words[0]);
    major.style.cssText = 'display:inline-block;padding:0;border:0;background:none;color:#2B2B2B;font-size:15px;font-weight:300;letter-spacing:0.14em;text-transform:uppercase;line-height:1.3;text-decoration:none;cursor:pointer;';
    container.appendChild(major);
    (function (el, w) {
      var s = document.querySelector('script[src*="int-bundle-upsell"]');
      var base = s ? s.src.replace(/int-bundle-upsell\.js.*$/, '') : '';
      var slug = String(w || '').toLowerCase().replace(/[^a-z]/g, '');
      if (!base || !slug) return;
      var url = base + 'woi-mask-' + slug + '.webp', img = new Image();
      img.onload = function () {
        if (!img.naturalWidth || !img.naturalHeight) return;
        var H = Math.min(96, Math.round(220 * img.naturalHeight / img.naturalWidth)), W = Math.round(H * img.naturalWidth / img.naturalHeight);
        if (el.tagName !== 'A') { el.setAttribute('role', 'img'); el.setAttribute('aria-label', w); }
        el.textContent = '';
        el.style.cssText = 'display:inline-block;width:' + W + 'px;height:' + H + 'px;padding:0;border:0;background-color:#2B2B2B;-webkit-mask:url(' + url + ') center/contain no-repeat;mask:url(' + url + ') center/contain no-repeat;text-decoration:none;cursor:pointer;';
      };
      img.src = url;
    })(major, words[0]);

    /* ONE Word since 2026-10-06 (Nils: "we are focusing on one word now, never 3"). The quiz still
       stores more entries in int_quiz_words; only words[0] is the result, so the supporting kicker
       and the second row of pills are gone. */
  }

  /* ── Quiz opener. INT 2026-10-06: the Find your Word quiz lives on /pages/your-word-of-intention
     (sections/int-quiz.liquid) and writes int_quiz_words itself. On that page window.intentionOpenQuiz
     starts it in place; everywhere else the visitor goes to the page. ── */
  if (!window.__intBundleOpenQuiz) {
    window.__intBundleOpenQuiz = function() {
      if (typeof window.intentionOpenQuiz === 'function') { window.intentionOpenQuiz(); return; }
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      window.location.href = root + 'pages/your-word-of-intention';
    };
  }

  /* ── Product page strip logic ── */
  if (window.__intPPBundleStripInit) return;
  window.__intPPBundleStripInit = true;

  function isWordProduct(item) {
    return WOI_TYPES.indexOf((item.product_type || '').trim()) !== -1;
  }

  function renderPPStrip(count) {
    var strip = document.getElementById('int-pp-bundle-strip');
    if (!strip) return;
    var savedWords = getSavedWords();

    strip.style.display = 'block';
    ['int-pp-bs-0','int-pp-bs-1','int-pp-bs-2','int-pp-bs-3'].forEach(function(id) {
      var el = document.getElementById(id); if (el) el.style.display = 'none';
    });

    var activeId = count === 0 ? 'int-pp-bs-0' : count === 1 ? 'int-pp-bs-1' : count === 2 ? 'int-pp-bs-2' : 'int-pp-bs-3';
    var activeEl = document.getElementById(activeId);
    if (!activeEl) return;
    activeEl.style.display = 'block';

    var savedSection   = activeEl.querySelector('.int-pp-bs-saved');
    var pillsContainer = activeEl.querySelector('.int-pp-bs-pills');
    var cta = activeEl.querySelector('[data-int-bundle-cta]');
    if (savedSection && pillsContainer && savedWords.length > 0) {
      renderPills(pillsContainer, savedWords);
      savedSection.style.display = 'block';
      if (cta) cta.textContent = cta.getAttribute('data-int-saved-text') || cta.textContent;
    } else if (savedSection) {
      savedSection.style.display = 'none';
      if (cta) cta.textContent = cta.getAttribute('data-int-default-text') || cta.textContent;
    }
  }
  function updatePPStrip() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var count = 0;
        (cart.items || []).forEach(function(item) {
          if (isWordProduct(item)) count += (item.quantity || 1);
        });
        window.__intPPWOICount = count;
        renderPPStrip(count);
      })
      .catch(function() { renderPPStrip(window.__intPPWOICount || 0); });
  }

  window.__intUpdatePPBundleStrip = updatePPStrip;

  var _bundleStripDebounce = null;
  window.__intUpdateBundleStrip = function() {
    clearTimeout(_bundleStripDebounce);
    _bundleStripDebounce = setTimeout(updatePPStrip, 300);
  };

  ['theme:cart:change', 'cart:updated', 'cart:refresh'].forEach(function(evt) {
    document.addEventListener(evt, function() {
      setTimeout(updatePPStrip, 400);
      setTimeout(updatePPStrip, 900);
    });
  });

  /* Self-healing: poll localStorage for int_quiz_words changes and re-render
     when they change. Catches all paths — modal close, cross-tab edits, manual
     console writes, future Klaviyo Smart Property sync, etc. */
  var _lastSavedWordsSig = JSON.stringify(getSavedWords());
  setInterval(function() {
    try {
      var currentSig = JSON.stringify(getSavedWords());
      if (currentSig !== _lastSavedWordsSig) {
        _lastSavedWordsSig = currentSig;
        updatePPStrip();
      }
    } catch(e) {}
  }, 800);

  /* Also listen to storage event for cross-tab changes (one tab takes quiz,
     another tab on PDP updates without refresh) */
  window.addEventListener('storage', function(e) {
    if (e.key === 'int_quiz_words') updatePPStrip();
  });

  /* Listen to custom event so int-reflection-trigger and the cart Custom Code
     Block can both signal a word change explicitly when they save */
  document.addEventListener('int:words:changed', updatePPStrip);

  var atcForm = document.querySelector('form[action="/cart/add"]');
  if (atcForm) {
    atcForm.addEventListener('submit', function() {
      setTimeout(updatePPStrip, 600);
      setTimeout(updatePPStrip, 1400);
    });
  }

  updatePPStrip();

})();
